import React from 'react';
import DayCardAddToMealButton from './DayCardAddToMealButton';

interface Entry {
  id: string;
  title: string;
  imageUrl: string;
  servings: number;
}

interface DayCardProps {
  dateISO: string;
  entries: Entry[];
  onAdd: () => void;
  onClickEntry: (entryId: string) => void;
  onRemoveEntry: (entryId: string) => void;
}

const fallbackRecipeImage = '/no-image.png';

const DayCard = ({ dateISO, entries, onAdd, onClickEntry }: DayCardProps) => {
  return (
    <div className="py-4">
      <div className="flex justify-between items-center mb-5">
        <h3 className="text-lg font-semibold">
          {new Date(dateISO).toLocaleDateString('en-US', {
            weekday: 'long',
          })}
        </h3>
        <DayCardAddToMealButton onAdd={onAdd} />
      </div>

      {entries.length > 0 && (
        <div className="flex space-x-4 overflow-x-auto hide-scrollbar">
          {entries.map((e) => (
            <div
              key={e.id}
              className="w-40 bg-white rounded-lg border border-gray-300 flex-shrink-0"
            >
              <img
                src={e.imageUrl || fallbackRecipeImage}
                alt={e.title}
                className="w-full h-20 object-cover rounded"
                onClick={() => onClickEntry(e.id)}
              />
              <h4
                className="mt-2 text-sm font-medium truncate px-2 "
                onClick={() => onClickEntry(e.id)}
              >
                {e.title}
              </h4>
              <p className="text-xs text-gray-500 p-2">
                {e.servings} serving(s)
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DayCard;
